module.exports = function () {

    if ($('.main-header--2024').length === 0) {
        return;
    }

    function isHamburgerMenuOpen() {
        return $('.main-nav__hamburger').hasClass('main-nav__hamburger--is-active');
    }  

    function openHamburgerMenu() {
        $('.main-nav__hamburger').addClass('main-nav__hamburger--is-active');
        $('.hamburger-nav').addClass('hamburger-nav--is-active');
        $('body').addClass('hamburger-nav--is-active');
        $('.main-header').addClass('hamburger-nav--is-active').addClass('main-header--with-open-header');

        ariaHideNonHeaderContent();
        updateHamburgerMenuAccessibilityElements();
    }

    function closeHamburgerMenu() {
        $('.main-nav__hamburger').removeClass('main-nav__hamburger--is-active');
        $('.hamburger-nav').removeClass('hamburger-nav--is-active');
        $('body').removeClass('hamburger-nav--is-active');                
        $('.main-header').removeClass('hamburger-nav--is-active');

        ariaUnhideNonHeaderContent();
        updateHamburgerMenuAccessibilityElements();

        if ($(document.activeElement).closest('.hamburger-nav').length > 0) {
            $(document.activeElement).closest('.main-header').find('.main-nav__hamburger').first().focus();
        }

        setTimeout(function () {
            $('.main-header').removeClass('main-header--with-open-header');
        }, 500);
    }

    function updateHamburgerMenuAccessibilityElements() {
        var $allFocusableElements = $('.hamburger-nav a');

        removeFocusableElementRestriction($('.main-nav__logo-wrapper, .main-nav__hamburger').add($allFocusableElements));

        if (isHamburgerMenuOpen()) {
            $('.main-nav__hamburger').attr('aria-expanded', 'true');
            $('.hamburger-nav').removeAttr('aria-hidden');

            if (ICF.Utils.Breakpoints.IsMobile()) {
                $('.hamburger-nav__header-link').add('.main-header__social-link').add('.hamburger-nav__header-toggle').attr('tabindex', '');

                $('.hamburger-nav__header').each(function () {
                    var $navHeader = $(this).find('.hamburger-nav__header-toggle');

                    if ($navHeader) {
                        var $navGroups = $(this).next('.hamburger-nav__groups');

                        if ($navHeader && $navHeader.hasClass('hamburger-nav__header-toggle--is-active')) {
                            $navHeader.attr('aria-expanded', 'true');
                            $navGroups.removeAttr('aria-hidden');
                            $navGroups.find('a').attr('tabindex', '');
                        }
                        else {
                            $navHeader.attr('aria-expanded', 'false');
                            $navGroups.attr('aria-hidden', 'true');
                            $navGroups.find('a:not(".main-header__social-link")').attr('tabindex', '-1');
                        }
                    }
                });
            }
            else {
                $allFocusableElements.attr('tabindex', '');
                $('.hamburger-nav__groups').removeAttr('aria-hidden');
                $('.hamburger-nav__header-toggle').attr('aria-expanded', 'true');
            }
            
            setFocusableElementRestriction($('.main-nav__logo-wrapper, .main-nav__hamburger').add($('.hamburger-nav [tabindex=""]')));
        }
        else {
            $('.main-nav__hamburger').attr('aria-expanded', 'false');
            $('.hamburger-nav').attr('aria-hidden', 'true');
            $('.hamburger-nav__groups--without-social-links').attr('aria-hidden', 'true');
            $('.hamburger-nav__header-toggle').attr('aria-expanded', 'false');
            $allFocusableElements.attr('tabindex', '-1')                        
        }
    }

    function isSearchPaneOpen() {
        return $('.main-nav__search-btn').hasClass('main-nav__search-btn--is-active');
    }

    function updateSearchWrapperHeight() {

        var $searchWrapperWithSuggestions = $('.search-wrapper--with-suggestions');
        if ($searchWrapperWithSuggestions.hasClass('search-wrapper--is-active')) {
            var containerHeight = $searchWrapperWithSuggestions.find('.search-wrapper__container').outerHeight(true);
            
            if (containerHeight + 80 <= $('body').outerHeight(true)) {
                var containerHeightValue = containerHeight + 'px';
                $searchWrapperWithSuggestions.css('height', containerHeightValue);
            }
            else {
                $searchWrapperWithSuggestions.css('height', 'calc(100% - 80px)');
                $searchWrapperWithSuggestions.css('overflow-y', 'scroll');
            }
        }
        else {
            $searchWrapperWithSuggestions.css('height', '0');
            $searchWrapperWithSuggestions.css('overflow-y', '');
        }
    };

    function openSearchPane() {
        $('.main-nav__search-btn').addClass('main-nav__search-btn--is-active');
        $('.search-wrapper').addClass('search-wrapper--is-active');
        $('body').addClass('search-pane--is-active');
        $('.main-nav__hamburger').addClass('main-nav__hamburger--is-faded');

        var $searchWrapperWithSuggestions = $('.search-wrapper--with-suggestions');
        if ($searchWrapperWithSuggestions.length) {
            $('.header-scrim').addClass('header-scrim--is-visible');
            $('.main-header').addClass('main-header--with-open-search');

            requestAnimationFrame(function () {
                $('.header-scrim').addClass('header-scrim--is-active');
            });

            updateSearchWrapperHeight();
        }

        ariaHideNonHeaderContent();
        updateSearchPaneAccessibilityElements();

        setTimeout(function () {
            $('.search-wrapper input').first().focus();
        }, 250);        
    }

    function closeSearchPane() {
        $('.main-nav__search-btn').removeClass('main-nav__search-btn--is-active');
        $('.search-wrapper').removeClass('search-wrapper--is-active');
        $('body').removeClass('search-pane--is-active');
        $('.main-nav__hamburger').removeClass('main-nav__hamburger--is-faded');

        var $searchWrapperWithSuggestions = $('.search-wrapper--with-suggestions');
        if ($searchWrapperWithSuggestions.length) {            
            updateSearchWrapperHeight();
            $('.header-scrim').removeClass('header-scrim--is-active');

            setTimeout(function () {
                $('.header-scrim').removeClass('header-scrim--is-visible');
                $('.main-header').removeClass('main-header--with-open-search');
            }, 250);   
        }

        ariaUnhideNonHeaderContent();        
        updateSearchPaneAccessibilityElements();

        if ($(document.activeElement).closest('.search-wrapper').length > 0) {
            $(document.activeElement).closest('.main-header').find('.main-nav__search-btn').first().focus();
        }
    }

    function updateSearchPaneAccessibilityElements() {        
        var $focusableElements = $('.search-wrapper').find('.search-control__search-input, .search-control__search-btn, .search-list__list-item__link, .featured-result-link');

        if (isSearchPaneOpen()) {
            $('.main-nav__search-btn').attr('aria-expanded', 'true');
            $('.search-wrapper').removeAttr('aria-hidden');
            $focusableElements.attr('tabindex', '');
            setFocusableElementRestriction($('.main-nav__logo-wrapper, .main-nav__search-btn').add($focusableElements));
        }
        else {
            $('.main-nav__search-btn').attr('aria-expanded', 'false');
            $('.search-wrapper').attr('aria-hidden', 'true');
            $focusableElements.attr('tabindex', '-1');
            removeFocusableElementRestriction($('.main-nav__logo-wrapper, .main-nav__search-btn').add($focusableElements));
        }
    }

    function isHeaderNavActive() {
        return $('.main-nav__center:not(.main-nav__center--is-disabled)').length > 0;
    }

    function activateHeaderNav() {        
        $('.main-nav__center').removeClass('main-nav__center--is-disabled').attr('aria-hidden', 'false');
        $('.main-nav__center .main-nav__dropdown-item__link').attr('tabindex', '');
    }

    function deactivateHeaderNav() {        
        $('.main-nav__center').addClass('main-nav__center--is-disabled').attr('aria-hidden', 'true');
        $('.main-nav__center .main-nav__dropdown-item__link').attr('tabindex', '-1');

        if (isAnyHeaderNavDropdownOpen()) {
            closeHeaderNavDropdown();
        }
    }

    function isAnyHeaderNavDropdownOpen() {
        return $('.main-nav__dropdown-item--is-active').length > 0;
    }
       
    function openHeaderNavDropdown(mainNavDropdownItemLink) {
        $(mainNavDropdownItemLink).parent().addClass('main-nav__dropdown-item--is-active');

        var distanceToTop = $(document).scrollTop() * -1;
        $('body').addClass('with-open-header').css('top', distanceToTop + 'px')
        
        $('.header-scrim').addClass('header-scrim--is-visible');
        $('.main-header').addClass('main-header--with-open-header');

        requestAnimationFrame(function () {
            $('.header-scrim').addClass('header-scrim--is-active');
        });

        var $content = $(mainNavDropdownItemLink).siblings('.main-nav__dropdown-item__content');
        var contentHeight = $content.find('.main-nav__dropdown-item__content-container').outerHeight() + 'px';
        $content.css('height', contentHeight);

        ariaHideNonHeaderContent();
        updateHeaderNavDropdownAccessibilityElements();
    }

    function closeHeaderNavDropdown(deactivateScrimAndCloseHeader) {

        if (typeof deactivateScrimAndCloseHeader === 'undefined') {
            deactivateScrimAndCloseHeader = true;
        }

        $('.main-nav__search-btn').attr('aria-expanded', 'true');

        $('body').removeClass('with-open-header').css({
            'top': ''
        });

        if (deactivateScrimAndCloseHeader) {
            $('.header-scrim').removeClass('header-scrim--is-active');
            setTimeout(function () {
                $('.header-scrim').removeClass('header-scrim--is-visible');
            }, 250);

            setTimeout(function () {
                $('.main-header').removeClass('main-header--with-open-header');
            }, 600);
        }

        $('.main-nav__dropdown-item__link').each(function (i, el) {
            $(this).parent().removeClass('main-nav__dropdown-item--is-active');
            var $content = $(this).siblings('.main-nav__dropdown-item__content');
            $content.css('height', '0px');
        });

        ariaUnhideNonHeaderContent();
        updateHeaderNavDropdownAccessibilityElements();

        if ($(document.activeElement).closest('.main-nav__dropdown-item__content').length > 0)
        {
            $(document.activeElement).closest('.main-nav__dropdown-item').find('.main-nav__dropdown-item__link').first().focus();
        }
    }

    function updateHeaderNavDropdownAccessibilityElements() {       
        removeFocusableElementRestriction($('.main-nav__logo-wrapper, .main-nav__dropdown-item__link, .main-nav__search-btn, .main-nav__hamburger, header [tabindex=""]'));
        
        if (ICF.Utils.Breakpoints.IsAtLeastTablet()) {
            $('.main-nav__dropdown-item').each(function () {
                if ($(this).hasClass('main-nav__dropdown-item--is-active')) {
                    $(this).find('.main-nav__dropdown-item__link').attr('aria-expanded', 'true');
                    $(this).find('.main-nav__dropdown-item__content').attr('aria-hidden', 'false').find('a').attr('tabindex', '');
                }
                else {                                        
                    $(this).find('.main-nav__dropdown-item__link').attr('aria-expanded', 'false');
                    $(this).find('.main-nav__dropdown-item__content').attr('aria-hidden', 'true').find('a').attr('tabindex', '-1');
                }
            });

            if (isAnyHeaderNavDropdownOpen()) {
                setFocusableElementRestriction($('.main-nav__logo-wrapper, .main-nav__dropdown-item__link, .main-nav__search-btn, .main-nav__hamburger, header [tabindex=""]'));
            }            
        }        
    }

    function ariaHideNonHeaderContent() {        
        $('main, footer').attr('aria-hidden', 'true');
    }

    function ariaUnhideNonHeaderContent() {        
        $('main, footer').removeAttr('aria-hidden');
    }

    // add the classes that cause tab and shift+tab to be restricted to a subset of elements.
    var setFocusableElementRestriction = function (focusableElements) {
        var firstFocusableElement = focusableElements.first();
        var lastFocusableElement = focusableElements.last();

        $(lastFocusableElement).addClass('focus-trap-focusable-last');
        $(firstFocusableElement).addClass('focus-trap-focusable-first');
    }

    // remove the classes that cause tab and shift+tab to be restricted to a subset of elements.
    var removeFocusableElementRestriction = function () {
        $('.focus-trap-focusable-first').removeClass('focus-trap-focusable-first');
        $('.focus-trap-focusable-last').removeClass('focus-trap-focusable-last');
    }
       
    // close menus when pressing esc
    $(document).on('keyup', function (evt) {
        if (evt.keyCode == 27) {
            // if hamburger is open, close it
            if (isHamburgerMenuOpen()) {
                closeHamburgerMenu();
                activateHeaderNav();
            }
            // if search pane is open, close it
            if (isSearchPaneOpen()) {
                closeSearchPane();
                activateHeaderNav();
            }
            // if any header nav dropdown is open, close it
            if (isAnyHeaderNavDropdownOpen()) {
                closeHeaderNavDropdown();
            }
        }
    });
    
    // tab and shift+tab handling
    $(document).on('keydown', function (e) {
        if (isHamburgerMenuOpen() || isSearchPaneOpen() || isAnyHeaderNavDropdownOpen()) {
            // if we're tabbing, tab through the focusable elements in the navigation modal.
            if (e.key === 'Tab' || e.keyCode === 9) {
                if ($('.focus-trap-focusable-first.focus-trap-focusable-last').length <= 0) {

                    if (e.shiftKey) /* shift tab keypress */ {
                        if ($(document.activeElement).hasClass('focus-trap-focusable-first')) {
                            $('.focus-trap-focusable-last').focus();
                            e.preventDefault();
                        }
                    } else /* tab keypress */ {
                        if ($(document.activeElement).hasClass('focus-trap-focusable-last')) {
                            $('.focus-trap-focusable-first').focus();
                            e.preventDefault();
                        }
                    }
                } else {
                    e.preventDefault();
                }
            }
        }
    });

    // hamburger menu toggle
    $('.main-nav__hamburger').click(function (e) {
        e.preventDefault();        
        
        if (isHamburgerMenuOpen()) {            
            closeHamburgerMenu();
            activateHeaderNav();
        }
        else {
            if (isHeaderNavActive()) {
                deactivateHeaderNav();
            }
            if (isSearchPaneOpen()) {
                closeSearchPane();
            }
            
            openHamburgerMenu();
        }
    });

    // hamburger nav header toggle
    $('.hamburger-nav__header-toggle').click(function (e) {
        e.preventDefault();

        var $groupToToggle = $(this).parent().siblings('.hamburger-nav__groups').first();

        if ($(this).hasClass('hamburger-nav__header-toggle--is-active')) {
            $(this).removeClass('hamburger-nav__header-toggle--is-active');

            $groupToToggle.css({
                height: '0px'
            });
        }
        else {
            var height = 0;
            $groupToToggle.find('.hamburger-nav__group').each(function (i) {
                height += $(this).outerHeight(true);
            });

            $(this).addClass('hamburger-nav__header-toggle--is-active');

            $groupToToggle.css({
                height: height + 'px'
            });
        }        

        updateHamburgerMenuAccessibilityElements();
    });

    // main navigation item menu toggle
    $('.main-nav__dropdown-item').not('.main-nav__dropdown-item--with-logo').find('.main-nav__dropdown-item__link:not(.main-nav__dropdown-item__link--standalone)').click(function (e) {
        e.preventDefault();

        if (!$('.main-nav__center').hasClass('main-nav__center--is-disabled')) {                        
            if ($(this).parent().hasClass('main-nav__dropdown-item--is-active')) {
                closeHeaderNavDropdown();                
            }
            else {
                if (isSearchPaneOpen()) {
                    closeSearchPane();
                }
                else {
                    closeHeaderNavDropdown(false);
                }                
                openHeaderNavDropdown(this);
            }
        }
    });

    // search pane toggle
    $('.main-nav__search-btn').click(function (e) {
        e.preventDefault();

        if (isSearchPaneOpen()) {
            closeSearchPane();
            activateHeaderNav();            
        }
        else {
            if (isHeaderNavActive()) {
                closeHeaderNavDropdown(false);
            }
            if (isHamburgerMenuOpen()) {
                closeHamburgerMenu();
            }
            if (!isHeaderNavActive()) {
                activateHeaderNav();
            }
            openSearchPane();            
        }
        return false;
    });

    $('.search-wrapper__search-btn').click(function() {
        $(this).closest('form').submit();
    });

    // close header if clicked out of it
    var mainHeaderElement = document.getElementsByClassName('main-header')[0];
    if (typeof mainHeaderElement !== 'undefined') {
        document.addEventListener('click', function (event) {
            if (!mainHeaderElement.contains(event.target)) {
                var modalWrapperElement = document.getElementsByClassName('modaal-wrapper')[0];
                if (typeof modalWrapperElement == 'undefined' || (typeof modalWrapperElement !== 'undefined' && !modalWrapperElement.contains(event.target))) {
                    if (isSearchPaneOpen()) {
                        closeSearchPane();
                        activateHeaderNav();
                    }

                    closeHeaderNavDropdown();
                }
            }
        });
    }    

    var checkHeaderNavigationGroupsForSocialLinks = function () {
        $('.hamburger-nav__groups').each(function (i, el) {
            var $container = $(this).find('.main-header__social-link-items-container');

            if (!$container.length) {
                $(this).addClass('hamburger-nav__groups--without-social-links')
            }
        });
    };

    var resetHeaderHeights = function () {

        if (ICF.Utils.Breakpoints.IsMobile()) {
            var $hamburgerNavSections = $('.hamburger-nav__section');

            $hamburgerNavSections.each(function (i, navSection) {
                var $navSection = $(navSection);
                var $activeHeaderToggle = $navSection.find('.hamburger-nav__header-toggle--is-active');

                if ($activeHeaderToggle.length) {
                    var $navGroupItems = $navSection.find('.hamburger-nav__group');
                    var height = 0;

                    $navGroupItems.each(function (j) {
                        height += $(this).outerHeight(true);
                    });

                    $navSection.find('.hamburger-nav__groups:not(.hamburger-nav__groups--social)').css({
                        height: height + 'px'
                    });
                }
                else {
                    $navSection.find('.hamburger-nav__groups:not(.hamburger-nav__groups--social)').css({
                        height: '0px'
                    });
                }
            });
        }
        else {
            var $activeItem = $('.main-nav__dropdown-item.main-nav__dropdown-item--is-active');

            if ($activeItem.length) {
                var height = $activeItem.find('.main-nav__dropdown-item__content-container').outerHeight() + 'px';
                $activeItem.find('.main-nav__dropdown-item__content').css('height', height);
            }

            $('.hamburger-nav__groups').css('height', '');
        }

        updateHeaderNavDropdownAccessibilityElements();
    };

    // check to see if header should have class that applies box shadow
    var checkHeaderPosition = function () {
        var $header = $('.main-header');

        if ($(window).scrollTop() > $header.height()) {
            $header.addClass('header--is-scrolled');
            $('body').addClass('header--is-scrolled');
        }
        else {
            $header.removeClass('header--is-scrolled');
            $('body').removeClass('header--is-scrolled');
        }
    };

    $(window).resize(function () {
        if (isAnyHeaderNavDropdownOpen()) {
            if (ICF.Utils.Breakpoints.IsMobile() || ICF.Utils.Breakpoints.IsTablet()) {
                closeHeaderNavDropdown();
            }
        }

        requestAnimationFrame(resetHeaderHeights);
        updateSearchWrapperHeight();

        if (isHamburgerMenuOpen()) {
            updateHamburgerMenuAccessibilityElements();
        }                               
    });

    $(window).scroll(function () {
        requestAnimationFrame(checkHeaderPosition);
    });

    checkHeaderNavigationGroupsForSocialLinks();
    checkHeaderPosition();    
    updateHeaderNavDropdownAccessibilityElements();    
    updateHamburgerMenuAccessibilityElements();    
    updateSearchPaneAccessibilityElements();
};